import { Component, input, model, output } from "@angular/core";
import { StandardBottomSheetComponent } from "../../../../../../shared/components/standard-bottom-sheet/standard-bottom-sheet.component";
import { ChecklistSection } from "../../job-single-area-checklist.component";

/**
 * Lists the checklist sections for the current area so the CM can jump straight to one.
 *
 * Shown from the single-area checklist's "View Sections" footer action and from tapping a
 * section's own sticky header.
 */
@Component({
  selector: "app-checklist-sections-sheet",
  standalone: true,
  imports: [StandardBottomSheetComponent],
  templateUrl: "./checklist-sections-sheet.component.html",
  styleUrl: "./checklist-sections-sheet.component.scss"
})
export class ChecklistSectionsSheetComponent {
  isOpen = model<boolean>(false);
  sections = input<ChecklistSection[]>([]);
  bqStep = input<number>(0);

  readonly sectionSelected = output<number>();

  isSectionComplete(section: ChecklistSection): boolean {
    return section.totalCount > 0 && section.answeredCount === section.totalCount;
  }

  onSelectSection(sectionId: number): void {
    this.sectionSelected.emit(sectionId);
  }
}
